import { zetApi } from '@zet/network'

type IEditedDetailsParams = {
  customerId: number
  employmentType: string
  annualIncome: string
  modeOfIncome: number
  dob: string
  pinCode: string
  fullName: string
}

const verifyEditedDetails = async ({
  customerId,
  employmentType,
  annualIncome,
  modeOfIncome,
  dob,
  pinCode,
  fullName,
}: IEditedDetailsParams) => {
  try {
    const { data } = await zetApi.post('/customer/editDetails', {
      customerId,
      employmentType,
      annualIncome,
      modeOfIncome,
      dob,
      pinCode,
      fullName,
    })

    if (data?.data) return data?.data
    return data?.error
  } catch (error) {
    throw 'Something went wrong'
  }
}
export { verifyEditedDetails }
